// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2lUxl","loading":"styles_loading__88cSH"};